import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import { ExamCompassContext } from '../Context/context';

// svg
// import logoTwo from '../Assets/compass-logo-2.svg';
import sitting from '../Assets/sitting-room.svg';
import game from '../Assets/game.svg';

const SuccessOne: React.FC = () => {
  // From comtext
  // const { handleClose } = useContext(ExamCompassContext)

  const [countDown, setCountDowm] = useState<number>(30);

  useEffect(() => {
    const count = setInterval(() => {
      setCountDowm((prev) => {
        if (prev > 0) {
          return prev - 1;
        } else {
          clearInterval(count);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(count);
  }, []);

  console.log(countDown);

  return (
    <section className='bg-white w-full h-[100vh] flex items-center justify-center'>
      <div className='container flex items-center justify-center'>
        <div className='w-full md:w-[92%] lg:w-full h-[542.56px] relative p-4 pb-6 bg-white overflow-hidden flex items-center'>
          <div className='w-full flex flex-col items-center justify-center gap-3'>
            <h2 className='text-[30px] md:text-[2em] text-darkGreen font-bold text-center mb-3'>
              Registration Successful
            </h2>
            <h3 className='text-[20px] md:text-[1em] text-darkGreen font-bold text-center mb-3'>
              A mail has been sent to your email.
              Please click the link or button sent to activate your account
            </h3>
            <Link to={'/login'}>
              <p className='text-lemonGreen text-[14px] lg:text-[14px] font-semibold text-center cursor-pointer'>
                Go to Login
              </p>
            </Link>
          </div>
          <img
            className='hidden w-[250px] lg:w-[330px] md:block absolute -left-4 -bottom-4 lg:bottom-0'
            src={game}
            alt='Anim'
          />
          <img
            className='hidden w-[250px] lg:w-[270px] md:block absolute -right-4 -bottom-4 -lg:bottom-1'
            src={sitting}
            alt='Anim'
          />
        </div>
      </div>
    </section>
  );
};

export default SuccessOne;
